import { render, staticRenderFns } from "./ConfiguracaoFinanceiraUnidade.vue?vue&type=template&id=5825bc50&scoped=true&"
import script from "./ConfiguracaoFinanceiraUnidade.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoFinanceiraUnidade.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoFinanceiraUnidade.vue?vue&type=style&index=0&id=5825bc50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825bc50",
  null
  
)

export default component.exports